// --------------------------------------------------------------
// Created On: 2024-07-26
// Author: Dimitra Weinstein
//
// Last Modified: 2024-07-26
// Modified By: Dimitra Weinstein
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Card from "../../components/Card/Card";
import TextBlurb from "../../components/TextBlurb/TextBlurb";
import styles from "./PartNotSellablePage.module.scss";

// Error page for a part that is not sellable or does not exist.
export default function PartNotSellablePage(): Component {
  return (
    <div className={`${styles.body} p-4`} data-test="500-error-card">
      <Card title="Part Search Error">
        <div className="my-5">
          <TextBlurb
            title="Part Not Sellable."
            paragraph="The part you are searching for is not sellable or does not exist. Please go back to the previous page and try again."
            icon="exclamation-triangle"
          />
        </div>
      </Card>
    </div>
  );
}
